








































































































































































































































































































































































































































































































































































  
  import PhotoHeader from '../components/organization/PhotoHeader.vue'
  import Main from '../components/organization/Main.vue'
  import Paragraph from '@/components/organization/Paragraph.vue'
  import Speakers from '@/components/organization/Speakers.vue'
  import MiniCourse from '../components/miniCourse/index.vue'
  import Programacao from './Programacao.vue'
  import { miniCourses_Section } from '@/models/miniCourses'
  import { Component, Vue, Prop } from 'vue-property-decorator'
  


  @Component({
  components: {
    PhotoHeader,
    Main,
    MiniCourse,
    Paragraph,    
    Programacao
  },
})
export default class MiniCourses extends Vue {  

  //@Prop(String) private title: String = "";
  //@Prop(String) private description: String = "";
  //@Prop(String) private background: String = "assets/img/bannerhackthon.png";

  private visibleCheckpoint = false;
  private visibleMentores = false;
  private visibleCursos = false;
  private visibleGeral = true;
  private visibleAvaliadores = false;
  private visibleDesafio = false;
  private filtered_courses = {};
  private coursesList = miniCourses_Section;
  private title = "";
  private description = "";
  private background = "assets/img/bannerhackthon.jpg";

  constructor() {
    super();

  }

  data () {
    return {
    publicPath: process.env.BASE_URL
    }
  }

  mostrar_apenas_geral() {
    this.visibleCheckpoint  = false;
    this.visibleMentores    = false;
    this.visibleCursos      = false;
    this.visibleGeral       = true;
    this.visibleAvaliadores = false;
    this.visibleDesafio = false;

  const func = () => {
    const geral = document.getElementById("geral");
    geral.scrollIntoView({behavior: "smooth"})
  }

  setTimeout(func, 100);
  }

  abrir_edital() {
    const caminho = process.env.BASE_URL;
    const caminhoPdf = `${caminho}EDITAL HACKA PUC 2023.pdf`;
    window.open(caminhoPdf, '_blank');
  }

  /* baixar_desafio() {
    const caminho = process.env.BASE_URL;
    const caminhoDocx = `${caminho}RACKATHON LG - Dia do Pobre.docx`;
    window.open(caminhoDocx);
  } */


  mostrar_apenas_checkpoint() {
    
    this.visibleMentores    = false;
    this.visibleCursos      = false;
    this.visibleGeral       = false;
    this.visibleCheckpoint  = true;
    this.visibleAvaliadores = false;
    this.visibleDesafio     = false;

    const func = () =>{
      const checkpoint = document.getElementById("checkpoint");
      checkpoint.scrollIntoView({behavior: 'smooth'})
    }
    

    setTimeout(func, 100);
  }

  filterCourses() {      
    this.mostrar_apenas_lista_cursos()
    //let data = e.target.innerText
    let filtro = ''
    this.filtered_courses = this.coursesList.map(item => {
      const minicurso = item.minicurso.filter(aux => {
        return aux.date == filtro
      })

      return { ...item, minicurso }
    })

    const func = () => {
      const cursos = document.getElementById("cursos");
      cursos.scrollIntoView({behavior: "smooth"})
    }

    setTimeout(func, 100);

  }

  mostrar_apenas_lista_cursos() {
    this.visibleCheckpoint  = false;
    this.visibleMentores    = false;      
    this.visibleGeral       = false;
    this.visibleCursos      = true;
    this.visibleAvaliadores = false;
    this.visibleDesafio     = false;
  }

  mostrar_apenas_mentores() {

    this.visibleCheckpoint  = false;      
    this.visibleCursos      = false;
    this.visibleGeral       = false;
    this.visibleMentores    = true;
    this.visibleAvaliadores = false;
    this.visibleDesafio     = false;

    const func = () => {
      const mentores = document.getElementById("mentores");
      mentores.scrollIntoView({behavior: "smooth"})
    }

    setTimeout(func, 100);

  }

  mostrar_apenas_avaliadores() {
    this.visibleCheckpoint  = false;      
    this.visibleCursos      = false;
    this.visibleGeral       = false;
    this.visibleMentores    = false;
    this.visibleAvaliadores = true;
    this.visibleDesafio     = false;

    const func = () => {
      const avaliadores = document.getElementById("avaliadores");
      avaliadores.scrollIntoView({behavior: "smooth"})
    }

    setTimeout(func, 100);

  }

  mostrar_apenas_desafio() {
    this.visibleMentores    = false;
    this.visibleCursos      = false;
    this.visibleGeral       = false;
    this.visibleCheckpoint  = false;
    this.visibleAvaliadores = false;
    this.visibleDesafio     = true;

    const func = () =>{
      const desafio = document.getElementById("desafio");
      desafio.scrollIntoView({behavior: 'smooth'})
    }
    

    setTimeout(func, 100);
  }

}



